module.exports = __webpack_public_path__ + "static/media/img-about-panel.24ab4f42.jpg";